document.addEventListener("DOMContentLoaded", () => {
  const titleSpans = document.querySelectorAll(
    ".product__title h1 span, .product__title h1 animate-element"
  );

  titleSpans.forEach((el) => {
    el.style.fontFamily = "'Outfit', sans-serif";
    el.style.fontWeight = "500"; // match display weight, optional
  });
});
